<h1>Your Profile</h1>

<form (ngSubmit)="submit()" #profileForm="ngForm">
  <div class="card">
    <h2>Personal Details</h2>

    <label for="full_name">Full Name</label>
    <input id="full_name" name="full_name" type="text" required
           [(ngModel)]="profile.personal_details.full_name" />

    <label for="email">Email</label>
    <input id="email" name="email" type="email" required
           [(ngModel)]="profile.personal_details.email" />

    <label for="phone">Phone</label>
    <input id="phone" name="phone" type="text"
           [(ngModel)]="profile.personal_details.phone" />

    <label for="country">Country</label>
    <input id="country" name="country" type="text"
           [(ngModel)]="profile.personal_details.country" />

    <label for="bio">Short Bio</label>
    <textarea id="bio" name="bio" rows="3"
              [(ngModel)]="profile.personal_details.bio"></textarea>
  </div>

  <div class="card">
    <h2>Preferred Companies</h2>
    <p class="muted">Add the companies whose share price you'd like to track. A ticker symbol is optional -- the AI agent will resolve it automatically if left blank.</p>

    <div class="company-row" *ngFor="let company of profile.preferred_companies; let i = index" style="margin-bottom: 10px;">
      <input type="text" placeholder="Company name (e.g. Apple)" name="company_name_{{i}}"
             [(ngModel)]="company.name" />
      <input type="text" placeholder="Symbol (optional, e.g. AAPL)" name="company_symbol_{{i}}"
             [(ngModel)]="company.symbol" />
      <button type="button" class="secondary" (click)="openSymbolLookup(i)">Lookup</button>
      <button type="button" class="ghost" (click)="removeCompany(i)">Remove</button>
    </div>

    <button type="button" class="secondary" (click)="addCompany()">+ Add another company</button>
  </div>

  <button type="submit" [disabled]="saving">
    {{ saving ? 'Saving...' : 'Save & View Dashboard' }}
  </button>

  <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p class="muted" *ngIf="successMessage">{{ successMessage }}</p>
</form>

<div class="modal-backdrop" *ngIf="lookupOpen" (click)="closeSymbolLookup()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <h3>Find ticker symbol</h3>
    <div class="lookup-row">
      <input type="text" placeholder="Company name (e.g. Apple)" [(ngModel)]="lookupQuery"
             name="lookup_query" (keyup.enter)="runSymbolLookup()" />
      <button type="button" (click)="runSymbolLookup()" [disabled]="lookupLoading || !lookupQuery.trim()">
        {{ lookupLoading ? 'Searching...' : 'Search' }}
      </button>
    </div>

    <ul class="lookup-results" *ngIf="lookupResults.length">
      <li *ngFor="let match of lookupResults">
        <div>
          <strong>{{ match.symbol }}</strong>
          <span class="muted">{{ match.name }}<ng-container *ngIf="match.exchange"> · {{ match.exchange }}</ng-container></span>
        </div>
        <button type="button" class="secondary" (click)="selectSymbol(match)">Use</button>
      </li>
    </ul>

    <p class="muted" *ngIf="lookupSearched && !lookupResults.length && !lookupLoading">
      No matching ticker symbol found.
    </p>

    <button type="button" class="ghost" (click)="closeSymbolLookup()">Close</button>
  </div>
</div>

<div class="toast" *ngIf="notificationVisible" role="status" (click)="dismissNotification()">
  {{ notificationMessage }}
</div>

